import { Component, OnInit, Input } from '@angular/core';
import { UtilityAddEditComponent } from './parts/add-edit/add-edit.component';

@Component({
  selector: 'app-utility',
  templateUrl: './utility.component.html',
  styleUrls: ['./utility.component.scss']
})
export class UtilityComponent implements OnInit {

  @Input() object: Object;
  @Input() summaryOnly: boolean = false;
  public key: string;
  public extraData: Object;

  constructor() { }

  ngOnInit(): void {

    this.key = 'utility';
    this.extraData = {
      heading: this.object['title']['rendered'],
      component: UtilityAddEditComponent,
      showSummaryOnly: this.showSummaryOnly(),
      options: {
        class: 'modal-lg'
      },
      section: {
        key: 'utility',
        title: 'Utilities',
        type: 'children',
        childType: 'utility',
        plural: 'utilities',
        singular: 'Utility',
        min: 0,
        max: 0,
      },
    }

  }

  showSummaryOnly() {

    if( typeof( this.object ) === 'undefined' ) {
      return true;
    }

    return this.summaryOnly;

  }

}
